import { Box, SuccessAnimation, Text } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { NewLoginView } from '../../../../common/enums/newLoginView';
import { TwoFactorAuthenticationType } from '../../../../common/enums/twoFactorAuthenticationType';
import { GeneralError } from '../errors/GeneralError';
import { ChooseMfaMethod } from './ChooseMfaMethod';
import { DownloadMfaApp } from './DownloadMfaApp';
import { IdleUserModalNotLoggedIn } from './IdleUserModalNotLoggedIn';
import { ScanMfaQrCode } from './ScanMfaQrCode';
import { SetHardwareToken } from './SetHardwareToken';

interface IMfaSetupAtLoginViewsProps {
    password: string;
    userName: string;
}

export function MfaSetupAtLogin(props: IMfaSetupAtLoginViewsProps) {
    const [viewStep, setViewStep] = useState<NewLoginView>(NewLoginView.chooseMfaMethod);
    const [mfaType, setMfaType] = useState<TwoFactorAuthenticationType | undefined>();

    useEffect(() => {
        if (viewStep === NewLoginView.successPage) {
            setTimeout(() => (window.location.href = '/home'), 2000);
        }
    }, [viewStep]);

    let view: JSX.Element = <></>;

    if (viewStep === NewLoginView.chooseMfaMethod) {
        view = (
            <ChooseMfaMethod
                goBack={() => (window.location.href = '/home')}
                goToNextStep={() => {
                    mfaType === TwoFactorAuthenticationType.verificationApp
                        ? setViewStep(NewLoginView.downloadMfaApp)
                        : setViewStep(NewLoginView.setHardwareToken);
                }}
                isSetupAtLogin={true}
                mfaType={mfaType}
                onChangeMfaType={(twoFactorAuthenticationType: TwoFactorAuthenticationType) => {
                    setMfaType(twoFactorAuthenticationType);
                }}
                skipStep={() => null}
            />
        );
    } else if (viewStep === NewLoginView.downloadMfaApp) {
        view = (
            <DownloadMfaApp
                goBack={() => setViewStep(NewLoginView.chooseMfaMethod)}
                goToNextStep={() => setViewStep(NewLoginView.scanMfaQrCode)}
            />
        );
    } else if (viewStep === NewLoginView.scanMfaQrCode) {
        view = (
            <ScanMfaQrCode
                goBack={() => setViewStep(NewLoginView.downloadMfaApp)}
                goToNextStep={() => setViewStep(NewLoginView.successPage)}
                noLoggedIn={true}
                password={props.password}
                userName={props.userName}
            />
        );
    } else if (viewStep === NewLoginView.setHardwareToken) {
        view = (
            <SetHardwareToken
                goBack={() => setViewStep(NewLoginView.chooseMfaMethod)}
                goToNextStep={() => setViewStep(NewLoginView.successPage)}
                isActivationFlow
                password={props.password}
                redirectHome
                userName={props.userName}
            />
        );
    } else if (viewStep === NewLoginView.successPage) {
        view = (
            <>
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                >
                    <SuccessAnimation size="large" />
                </Box>
                <Text>{getSuccessText()}</Text>
            </>
        );
    } else {
        view = <GeneralError />;
    }

    return (
        <>
            {view}
            <IdleUserModalNotLoggedIn />
        </>
    );

    function getSuccessText() {
        switch (mfaType) {
            case TwoFactorAuthenticationType.verificationApp:
                return 'Klaar! Vanaf nu kan je inloggen in Ksyos met wachtwoord en verificatieapp.';
            case TwoFactorAuthenticationType.verificationDevice:
                return 'Klaar! Vanaf nu kan je inloggen in Ksyos met wachtwoord en de hardware token.';
            default:
                return 'Klaar! Vanaf nu kan je inloggen in Ksyos.';
        }
    }
}
